import { images, links, TID } from "@/data";
import { Link } from "react-router-dom";

const CTA = () => {
  return (
    <section className="cta section">
      <div className="container">
        <div className="cta__card">
          <img className="cta__bg" src={images.ctaBungalows} alt="Overwater villas at sunset in the Maldives" loading="lazy" />
          <div className="cta__inner">
            <h2 className="cta__title">Shape the<br />Future of Travel</h2>
            <Link to="/partner" className="btn btn--solid" data-testid={TID.ctaWork}>
              <span className="btn__dot" />Let’s work together
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
